@import '../constants/spacing.module.less';

.feature-gate-disabled-text {
  color: var(--default--disabled--text-color--2);
}

.feature-gate-icon {
  width: 16px;
}

.clickable-icon {
  cursor: pointer;
}

.feature-gate-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: @space-8;
}
